<template>
  <!-- 首页 -->
  <div class="homeComponent">
    <!-- <div class="banner_warp" :style="{backgroundImage:backgroundImage}">
      <p>龙源果实微授权</p>
      <p>海量，优质，正版文章转授权服务</p>
      <p>
        整合龙源生态历经20年积累的优质期刊杂志内容，提供正版期刊文章转授权服务。帮您避
        <br />免侵权风险同时为客户降低成本，高效解决内容问题。
      </p>
      <div class="banner_button_warp">
        <button class="button_simple" v-show="!userInfo.unique_code" @click="goRouter('/login?state=2')">注册试用</button>
        <a
          target="_blank"
          href="http://wpa.qq.com/msgrd?v=3&amp;uin=1439649533&amp;site=qq&amp;menu=yes"
          class="hover"
          data-v-88c9c0ba
        >
          <button class="button_simple_2">客户咨询</button>
        </a>
      </div>
    </div> -->

    <div class="banner-obj">
      <div style="max-width: 1200px; margin: auto;">
        <img class="logo" src="@/assets/imgs/sol.png" />
        <div class="search-box">
          <div class="input-box">
            <input v-model="keyword" placeholder="龙源知识库搜索" />
          </div>
          <div class="btn-box" @click="search"><img src="@/assets/imgs/Forward.png" />搜索</div>
        </div>
        <div class="tips-box">
          <div>热门搜索</div>
          <router-link :to="`/searchResult?keyset=0&valset=${item}`" class="tips-item" :key="index"
            v-for="(item, index) in searchData">{{ item }}</router-link>
        </div>
      </div>
    </div>

    <div class="menu-box">
      <router-link :to="`${item.path}?initialState=${item.state}`" :key="index" class="menu-item"
        v-for="(item, index) in menuData">
        <div>{{ item.title }}</div>
        <img :src="item.img" />
      </router-link>
    </div>


    <div class="main-box">
      <div class="left-box">
        <div class="tab-box">
          <div class="tab-item" @click="getList(item.channel_id)" :class="item.channel_id == tabDataId ? 'active' : ''"
            v-for="(item, index) in tabData">
            {{ item.channel_name }}</div>
        </div>
        <div class="list-box" v-loading="loading">
          <router-link :to="`/articledetails?initialState=${item.TitleID}`" class="list-item"
            v-for="(item, index) in listData" :key="item.TitleID">
            <div class="list-item-info">
              <div class="list-item-info-title">{{ item.Title }}</div>
              <div class="list-item-info-subtitle">{{ item.Summary }}</div>
              <div class="list-item-info-desc">{{ item.MagazineName }} {{ item.Year }} 年 {{ item.Issue }} 期 人物 {{
                item.Author }}
              </div>
            </div>
            <img style="margin-left: 20px;" v-if="item.CoverImg" :src="item.CoverImg" />
          </router-link>
        </div>
      </div>
      <div class="right-box">
        <div class="right-title">时事文章</div>
        <div class="rank-box">
          <router-link :to="`/articledetails?initialState=${item.TitleID}`" class="rank-item"
            v-for="(item, index) in rankData">
            <div class="rank-number">{{ index >= 9 ? index + 1 : `0${index + 1}` }}</div>
            <div class="rank-info">
              <div class="rank-title">{{ item.Title }}</div>
              <span>{{ item.Author }}</span>
            </div>
          </router-link>
        </div>
      </div>
    </div>

    <div class="homeMain_1200" style="margin-top: 72px">
      <!-- banner下边的莫块 -->
      <!-- <bannerBottomContent /> -->
      <titleStyle :CHN="'了解我们的产品'" :USA="'Our products'" />
      <!-- <div class="home_title">了解我们的产品</div> -->
      <!-- 我们的产品 -->
      <ourProductsContent :menu-list="productsData.menuList" :content-list="productsData.contentList" />
    </div>
    <titleStyle :CHN="'授权文章音频制作发行权'" :USA="'Our products'" />
    <audioProduction />
    <titleStyle :CHN="'龙源果实微授权'" :USA="'Authorization'" />
    <!-- <div class="home_title">龙源果实微授权</div> -->
    <microAuthorization />
    <div class="homeMain_1200">
      <titleStyle :CHN="'如何获取龙源果实的文章转授权？'" :USA="'Sublicense'" />
      <!-- <div class="home_title">如何获取龙源果实的文章转授权？</div> -->
      <howToObtainAuthorization />
      <titleStyle :CHN="'个性化需求定制'" :USA="'Personalized customization'" />
      <!-- <div class="home_title" style="border:none">个性化需求定制</div> -->
      <demandCustomization :summary="homeExperienceText" />
    </div>
    <!-- 底部   注册获得果实微授权免费体验账号 -->
    <!-- <getExperienceAccount /> -->
  </div>
</template>

<script>
import bannerBottomContent from "./homeComponents/bannerBottomContent.vue";
import ourProductsContent from "./homeComponents/ourProducts.vue";
import howToObtainAuthorization from "./homeComponents/howToObtainAuthorization.vue";
import demandCustomization from "./homeComponents/demandCustomization.vue";
import getExperienceAccount from "./homeComponents/getExperienceAccount.vue";
import microAuthorization from "./homeComponents/microAuthorization.vue";
import titleStyle from "../../components/common/titleStyle/titleStyle";
import audioProduction from "./homeComponents/audioProduction.vue"
import { bannerList } from "@/api/lxc"

import { channelList, ChannelPage } from "@/api/lyl";
export default {
  name: "home",
  data() {
    return {
      keyword: '',
      backgroundImage: "",
      productsData: {
        menuList: [
          {
            title: "海量优质内容",
            img: require("@/assets/home/hailiangyouzhineirong.png"),
            img2: require("@/assets/home/hailiangyouzhineirong2.png"),
            path: ""
          },
          {
            title: "安全绿色正版",
            img: require("@/assets/home/anquanlvsezhengban.png"),
            img2: require("@/assets/home/anquanlvsezhengban2.png"),
            path: ""
          },
          {
            title: "版权库免费信息流",
            img: require("@/assets/home/banquankumianfeixixiliu.png"),
            img2: require("@/assets/home/banquankumianfeixixiliu2.png"),
            path: ""
          },
          {
            title: "在线签约授权",
            img: require("@/assets/home/zaixianqianyueshouquan.png"),
            img2: require("@/assets/home/zaixianqianyueshouquan2.png"),
            path: ""
          }
        ],
        contentList: [
          {
            title:
              "龙源内容生态<span style='color:#50AEFE;'>+</span>优质版权内容合作商",
            img: require("@/assets/home/hailiangyouzhineirong.png"),
            content:
              "龙源自身历经<span style='color:#407DF8;'>20年</span>积累，汇集<span class='mainContentColor'>4300+</span>刊社媒体内容，拥有海量内容优势，依托于内容合作方<br>聚合行业内权威性版权内容，拥有从内容的生产到分发能力并储备了海量优质版权内容。",
            subChild: [
              { title: "版权文章", content: "2200万+" },
              { title: "期刊库存", content: "4300种" },
              { title: "新增/月", content: "20万篇" }
            ]
          },
          {
            title: "安全绿色正版",
            img: require("@/assets/home/anquanlvsezhengban.png"),
            content:
              "龙源自身所拥有4300种海量期刊库存均来自于所属刊社正版授权</br><span style='color:#407DF8;'>2200万+</span>版权内容文章全部由刊社运用三审三校机制为内容质量把关</br>正版可信赖内容源，提供独到且具有权威性的内容，专业视角、深度报道</br>除此以外，龙源获得政府高度认可的品牌和特许资质——《互联网出版许可》",
            subChild: []
          },
          {
            title: "高效便捷、低成本",
            img: require("@/assets/home/banquankumianfeixixiliu.png"),
            content:
              "果实根据行业人群来划分频道信息流。每一个频道下细分标签都代</br>表一个垂直领域，一键订阅信息流，你关注的领域资讯内容，持续<br>更新。同时支持智能搜索，帮你快速定位查找所需。使用方低成本</br>合规使用版权，同时支持API接入方式。",
            subChild: []
          },
          {
            title: "一站式授权服务",
            img: require("@/assets/home/zaixianqianyueshouquan.png"),
            content:
              "凡是使用龙源果实服务的客户无需经过繁琐的线下签约、授权等一系</br>列流程，购买服务后均可在线获取授权内容、以及电子版授权书，该</br>凭证可用于来保障客户的合法使用权益。杜绝100%的风险。",
            subChild: []
          }
        ]
      },
      homeExperienceText:
        "如需更深入了解龙源果实，请填写以下信息，我们会尽快安排专业人员与您沟通，提供最合适的企业定制服务",
      tabDataId: 'cff03be617e4463288e9aae9601b2c56',
      tabData: [
        {
          "cate_nums": "1",
          "channel_id": "cff03be617e4463288e9aae9601b2c56",
          "channel_name": "教育",
          "channel_pid": "0",
          "channel_pname": "教育",
          "childCate": [],
          "click_nums": 0,
          "content_nums": 0,
          "create_time": 1575595786000,
          "edit_time": 1575595786000,
          "id": 361,
          "rule_id": "1",
          "searchEntity": null,
          "status": "1",
          "torder": "19",
          "total_content_nums": 15104,
          "yesterday_content_nums": 0
        },
        {
          "cate_nums": "1",
          "channel_id": "41a31359a2aa40f9a431f576fbf6e2eb",
          "channel_name": "读书品书",
          "channel_pid": "cff03be617e4463288e9aae9601b2c56",
          "channel_pname": "教育",
          "childCate": [],
          "click_nums": 0,
          "content_nums": 0,
          "create_time": 1575595786000,
          "edit_time": 1575595786000,
          "id": 395,
          "rule_id": "1",
          "searchEntity": null,
          "status": "1",
          "torder": "19",
          "total_content_nums": 15104,
          "yesterday_content_nums": 0
        },
        {
          "cate_nums": "1",
          "channel_id": "5836fb2b0f1e421cb6f33542c01eb700",
          "channel_name": "儿童成长",
          "channel_pid": "cff03be617e4463288e9aae9601b2c56",
          "channel_pname": "教育",
          "childCate": [],
          "click_nums": 0,
          "content_nums": 0,
          "create_time": 1575522808000,
          "edit_time": 1575522808000,
          "id": 373,
          "rule_id": "1",
          "searchEntity": null,
          "status": "1",
          "torder": "16",
          "total_content_nums": 12746,
          "yesterday_content_nums": 0
        },
        {
          "cate_nums": "1",
          "channel_id": "90ba46784c704bd6ba5456dbb65eacf5",
          "channel_name": "教学设计",
          "channel_pid": "cff03be617e4463288e9aae9601b2c56",
          "channel_pname": "教育",
          "childCate": [],
          "click_nums": 0,
          "content_nums": 0,
          "create_time": 1575525914000,
          "edit_time": 1575525914000,
          "id": 385,
          "rule_id": "1",
          "searchEntity": null,
          "status": "1",
          "torder": "3",
          "total_content_nums": 27580,
          "yesterday_content_nums": 0
        },
        {
          "cate_nums": "1",
          "channel_id": "efbbf4c4d779448aaf3d4c3d55d04e6d",
          "channel_name": "职业教育",
          "channel_pid": "cff03be617e4463288e9aae9601b2c56",
          "channel_pname": "教育",
          "childCate": [],
          "click_nums": 0,
          "content_nums": 0,
          "create_time": 1575542937000,
          "edit_time": 1575542937000,
          "id": 394,
          "rule_id": "1",
          "searchEntity": null,
          "status": "1",
          "torder": "1",
          "total_content_nums": 2199,
          "yesterday_content_nums": 0
        },
        {
          "cate_nums": "1",
          "channel_id": "242a03b219d342749dd31dacdfdef77e",
          "channel_name": "心理教育",
          "channel_pid": "cff03be617e4463288e9aae9601b2c56",
          "channel_pname": "教育",
          "childCate": [],
          "click_nums": 0,
          "content_nums": 0,
          "create_time": 1575527647000,
          "edit_time": 1575527647000,
          "id": 387,
          "rule_id": "1",
          "searchEntity": null,
          "status": "1",
          "torder": "0",
          "total_content_nums": 7663,
          "yesterday_content_nums": 0
        }
      ],
      menuData: [
        {
          state: "cff03be617e4463288e9aae9601b2c56",
          title: "教育",
          img: require("@/assets/imgs/COVER.png"),
          path: "/channelList",
        },
        {
          state: "52f9d510f8f2440b8c69d5aad940cae0",
          title: "健康",
          img: require("@/assets/imgs/COVER-2.png"),
          path: "/channelList",
        },
        {
          state: "8b6ce687a68d421986532e556c7397ef",
          title: "人文",
          img: require("@/assets/imgs/COVER-3.png"),
          path: "/channelList",
        },
        {
          state: "04740082f07c42a7af39f8bb383d734f",
          title: "生活",
          img: require("@/assets/imgs/COVER-4.png"),
          path: "/channelList",
        },
        {
          state: "7616486caac44033989dae410f6d6494",
          title: "财经",
          img: require("@/assets/imgs/COVER-5.png"),
          path: "/channelList",
        },
        {
          state: "40bc7c7845da49ffa9391bb80f9efb03",
          title: "时政",
          img: require("@/assets/imgs/COVER-6.png"),
          path: "/channelList",
        },
        {
          state: "0b5a64db6a2342ecbcddc851b30597ab",
          title: "播客",
          img: require("@/assets/imgs/COVER-7.png"),
          path: "/channelList",
        },
        {
          state: "74ae01d740504589a4571a44b2a04edc",
          title: "军事",
          img: require("@/assets/imgs/COVER-8.png"),
          path: "/channelList",
        },
        {
          state: "ba81f542739a40dfadd473fa8a20d8c6",
          title: "科技",
          img: require("@/assets/imgs/COVER-9.png"),
          path: "/channelList",
        },
        {
          state: "c3cc2e7063ab4f1c9c193e2f93f1bbee",
          title: "三农",
          img: require("@/assets/imgs/COVER-10.png"),
          path: "/channelList",
        },
        {
          state: "287c6bc2998946ac824350f8732933d7",
          title: "娱乐",
          img: require("@/assets/imgs/COVER-11.png"),
          path: "/channelList",
        },
        {
          state: "d0a876c621bc4421a686dfe91880229f",
          title: "旅行",
          img: require("@/assets/imgs/COVER-12.png"),
          path: "/channelList",
        },
      ],
      loading: true,
      listData: [],
      rankData: []
    };
  },
  methods: {
    search() {
      if (!this.keyword) return;
      this.$router.push('/searchResult?keyset=0&valset=' + this.keyword)
    },
    async getList(id, field) {
      id && !field && (this.tabDataId = id)
      try {
        this.loading = true;
        const data = await ChannelPage({
          channel_id: '',
          channel_ids: id || this.tabDataId,
          page: 1,
          pageSize: 10,
          order_type: 2,
          has_img: 0,
          AudioRights: '',
          is_auth: ''
        });

        this.loading = false;
        if (field) {
          this[field] = data.article
        } else {
          this.listData = data.article
        }
        console.log(data);
      } catch (err) {
        this.listData = []
      }
    },
    goRouter(path) {
      this.$router.push({ path: path });
    },
    async bannerList() {
      try {
        const data = await bannerList({
          position: 1
        })
        this.backgroundImage = "url(" + data[0].img + ")"
      } catch (err) {
      }
    }
  },
  created() {
    this.bannerList()
    this.getList()
    this.getList('40bc7c7845da49ffa9391bb80f9efb03', 'rankData')
  },
  mounted() {
    this.bannerList()
    this.getList()
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo
    },

    searchData() {
      return [
        "公司财报",
        "行业研究",
        "高校与高等教育",
        "法律",
        "互联网行业",
        "干洗加盟",
        "艺术留学",
        "少儿乐器",
      ]
    }
  },
  components: {
    bannerBottomContent,
    ourProductsContent,
    howToObtainAuthorization,
    demandCustomization,
    getExperienceAccount,
    microAuthorization,
    titleStyle,
    audioProduction
  }
};
</script>

<style scoped lang="less">
.homeMain_1200 {
  width: 1200px;
  margin: auto;
  overflow: hidden;
}

.homeComponent {
  .banner_warp {
    height: 370px;
    background-color: #4e4646;
    background-size: cover;
    overflow: hidden;

    color: #ffffff;

    p {
      text-align: center;
    }

    p:nth-child(1) {
      font-size: 60px;
      padding: 58px 0 0 0;
    }

    p:nth-child(2) {
      font-size: 30px;
      padding: 8px 0;
    }

    p:nth-child(3) {
      font-size: 18px;
    }
  }

  .banner_button_warp {
    display: flex;
    justify-content: center;
    padding: 24px 0 0 0;

    button:nth-child(1) {
      margin-right: 48px;
    }
  }
}

.button_simple:hover,
.button_simple_2:hover {
  background: rgba(33, 77, 166, 1);
  border-color: rgba(33, 77, 166, 1);
  color: #fff;
}

.banner-obj {
  height: 500px;
  background: url(../../assets/imgs/bg.png) center;
  background-size: contain;
  background-color: #000;
  padding-top: 84px;
  box-sizing: border-box;

  .logo {
    display: block;
    width: 154px;
    height: 99px;
    margin: 0 auto 20px;
  }

  .search-box {
    margin: auto;
    width: 720px;
    height: 54px;
    border-radius: 6px;
    background-color: #fff;
    display: flex;
    overflow: hidden;

    .input-box {
      flex: 1;
      padding: 0 10px;

      input {
        width: 100%;
        height: 100%;
        border: 0;
        outline: 0;
        font-size: 13px;
      }
    }

    .btn-box {
      flex-basis: 130px;
      background-color: #EF0000;
      text-align: center;
      color: #fff;
      line-height: 54px;
      font-size: 16px;
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;

      img {
        margin-right: 4px;
        width: 24px;
        height: 24px;
      }
    }
  }
}

.tips-box {
  margin-top: 16px;
  color: #fff;
  column-gap: 10px;
  display: flex;
  justify-content: center;
  align-items: center;

  .tips-item {
    font-size: 12px;
    background-color: rgba(255, 255, 255, 0.2);
    border-radius: 100px;
    padding: 0 10px;
    height: 30px;
    line-height: 30px;
    cursor: pointer;
    color: #fff;
  }
}

.menu-box {
  width: min-content;
  margin: auto;
  padding: 20px 24px;
  background: url(../../assets/imgs/menu-bg.png) center;
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 12px;
  overflow: hidden;
  display: grid;
  column-gap: 10px;
  row-gap: 10px;
  grid-column: 6;
  grid-template-columns: repeat(6, 1fr);
  grid-column-gap: 10px;
  grid-row-gap: 10px;
  margin-top: -156px;

  &:hover {
    grid-template-rows: repeat(2, 1fr);

    .menu-item {

      &:nth-child(n+7) {
        display: block;
      }
    }
  }

  .menu-item {
    width: 175px;
    height: 116px;
    border-radius: 8px;
    background: rgba(48, 49, 51, 0.5021);


    &:nth-child(n+7) {
      display: none;
    }

    &>div {
      padding: 6px 8px;
      color: #fff;
      font-size: '15px';
      font-weight: 500;
      line-height: 24px;
    }

    img {
      display: block;
      width: 175px;
      height: 80px;
    }
  }
}

.main-box {
  width: 1140px;
  margin: auto;
  display: flex;
  margin-top: 30px;
  min-height: 200px;
}

.left-box {
  width: 720px;
}

.tab-box {
  display: flex;
  column-gap: 20px;
  margin-bottom: 12px;
}

.tab-item {
  padding: 0 10px;
  height: 34px;
  font-family: 阿里巴巴普惠体;
  font-size: 15px;
  font-weight: 500;
  line-height: 34px;
  letter-spacing: 0px;
  text-align: center;
  cursor: pointer;
  color: #909399;

  &:hover {
    box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.1);
    color: #303133;
  }

  &.active {
    box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.1);
    color: #303133;
  }
}

.list-box {
  min-height: 200px;
}

.list-item {
  padding: 20px 0;
  margin: 0 20px;
  box-shadow: inset 0px -0.5px 0px 0px #E6E6E6;
  display: flex;
  box-sizing: border-box;

  &-info {
    display: flex;
    flex-direction: column;

    &-title {
      font-family: 阿里巴巴普惠体;
      font-size: 18px;
      font-weight: 500;
      line-height: 24px;
      letter-spacing: 0px;
      margin-bottom: 4px;
    }

    &-subtitle {
      font-family: 阿里巴巴普惠体;
      font-size: 13px;
      font-weight: normal;
      line-height: 24px;
      letter-spacing: 0px;
      color: #909399;
      flex: 1;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
      margin-bottom: 24px;
    }

    &-desc {
      font-family: 阿里巴巴普惠体;
      font-size: 13px;
      font-weight: 500;
      line-height: 20px;
      letter-spacing: 0px;

      color: #909399;
    }
  }

  &>div {
    flex: 1
  }

  img {
    width: 120px;
    height: 120px;
    border-radius: 8px;
  }
}


.right-box {
  margin-left: auto;
  box-sizing: border-box;
  padding: 20px 18px;
  width: 400px;
  height: min-content;
  border-radius: 8px;
  opacity: 1;

  background: #FFFFFF;

  box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.1);

  .right-title {
    font-family: 阿里巴巴普惠体;
    font-size: 24px;
    font-weight: 500;
    line-height: 24px;
    letter-spacing: 0px;
    margin-bottom: 20px;
    color: #303133;
  }
}

.rank-item {
  display: flex;
  padding: 5px 0;
  cursor: pointer;




  &:nth-of-type(1) {
    .rank-number {
      color: #FFB200;
    }
  }

  &:nth-of-type(2) {
    .rank-number {
      color: #606266;
    }
  }

  &:nth-of-type(3) {
    .rank-number {
      color: #AA604F;
    }
  }

  .rank-info {
    overflow: hidden;
  }

  .rank-number {
    display: block;
    width: 20px;
    height: 20px;
    opacity: 1;
    font-family: 阿里巴巴普惠体;
    font-size: 13px;
    font-weight: 500;
    line-height: 20px;
    text-align: center;
    letter-spacing: 0px;
    margin-right: 6px;
    color: #909399
  }

  .rank-title {
    font-family: 阿里巴巴普惠体;
    font-size: 18px;
    font-weight: normal;
    line-height: 24px;
    letter-spacing: 0px;
    color: #606266;
    line-clamp: 1;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }

  span {
    font-family: 阿里巴巴普惠体;
    font-size: 12px;
    font-weight: 500;
    line-height: 12px;
    letter-spacing: 0px;
    color: #909399;
  }
}
</style>



// WEBPACK FOOTER //
// src/page/home/home.vue